var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 50.7,
    viewBox: "0 0 59 50.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_icon",
    "data-name": "email icon",
    transform: "translate(-1223 -290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "outgoing_mail_FILL0_wght400_GRAD0_opsz48",
    d: "M8.5,48A4.481,4.481,0,0,1,4,43.5v-33A4.481,4.481,0,0,1,8.5,6h42A4.481,4.481,0,0,1,55,10.5V27.9q-.525-.075-1.087-.113T52.75,27.75q-.6,0-1.125.038T50.5,27.9V14.025L29.2,29.1,8.5,14.1V43.5H34.825a8.389,8.389,0,0,0-.075,1.013v1.013q0,.6.037,1.237A6.717,6.717,0,0,0,34.975,48Zm2.7-37.5,18,13.05L47.65,10.5Zm-2.7,33v0Z",
    transform: "translate(1219 284)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "outgoing_mail_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "outgoing_mail_FILL0_wght400_GRAD0_opsz48",
    d: "M53.05,56.7,49.9,53.55,55.375,48H41.8V43.5H55.375L49.9,37.95l3.15-3.15L64,45.75Z",
    transform: "translate(1218 284)",
    fill: "#029eff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSendIcon);
export default __webpack_public_path__ + "static/media/email-send-icon.869723324a296c23d8d508a78b1e4026.svg";
export { ForwardRef as ReactComponent };